import React, { FunctionComponent, SVGProps } from 'react'

export const IconWhatsapp: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="28"
    height="29"
    viewBox="0 0 28 29"
    stroke="#FCFCFC"
    fill="#FCFCFC"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.95949 23.0503C11.2569 24.38 13.9594 24.8288 16.5632 24.313C19.167 23.7972 21.4944 22.352 23.1114 20.2469C24.7284 18.1418 25.5247 15.5204 25.3518 12.8715C25.1789 10.2226 24.0486 7.72704 22.1716 5.85001C20.2947 3.97299 17.7992 2.84264 15.1504 2.66973C12.5017 2.49681 9.88041 3.29313 7.77538 4.91021C5.67036 6.52729 4.22523 8.85475 3.70945 11.4587C3.19366 14.0626 3.64241 16.7652 4.97204 19.0627L3.54681 23.3181C3.49326 23.4787 3.48549 23.651 3.52437 23.8158C3.56325 23.9805 3.64725 24.1312 3.76695 24.2509C3.88665 24.3706 4.03732 24.4546 4.20208 24.4935C4.36684 24.5324 4.53917 24.5246 4.69975 24.4711L8.95949 23.0503Z"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.0838 16.3461C20.0141 16.2203 19.8276 16.1452 19.5469 15.9941C19.2672 15.8429 17.8912 15.1135 17.6341 15.0131C17.3779 14.9126 17.1915 14.8619 17.004 15.1642C16.8176 15.4655 16.2807 16.1452 16.1178 16.3461C15.9549 16.547 15.791 16.5723 15.5113 16.4212C15.2316 16.27 14.3293 15.9525 13.2603 14.9248C12.4287 14.1254 11.8665 13.1383 11.7035 12.836C11.5406 12.5347 11.6866 12.3714 11.826 12.2212C11.9522 12.0863 12.1057 11.8692 12.246 11.6927C12.3882 11.5182 12.4344 11.3924 12.5285 11.1905C12.6218 10.9896 12.5756 10.8131 12.505 10.662C12.4344 10.5118 11.8749 9.02763 11.6423 8.42401C11.4144 7.83663 11.1836 7.91576 11.0122 7.90663L10.4754 7.89648C10.2889 7.89648 9.98566 7.97156 9.72948 8.27387C9.47331 8.57619 8.75 9.30458 8.75 10.7888C8.75 12.273 9.75303 13.7064 9.89242 13.9073C10.0327 14.1082 11.8655 17.1536 14.6731 18.4593C15.3408 18.7697 15.8626 18.9553 16.2685 19.0943C16.9391 19.3236 17.5494 19.2911 18.0316 19.214C18.5693 19.1278 19.6873 18.4846 19.9208 17.7806C20.1544 17.0755 20.1544 16.4719 20.0838 16.3461Z"
      stroke="none"
    />
  </svg>
)
